import React, { Component, Fragment } from "react";
import Observer from "@researchgate/react-intersection-observer";
import { connect } from "react-redux";
import { trackSection } from "./services/analytics/actions";
import { hasLocationSelector } from "./services/location/reducer";

import Intro from "./scenes/Intro";
import Result from "./scenes/Result";
import Location from "./scenes/Location";
import Seats from "./scenes/Seats";
import Footer from "./scenes/Footer";

class Scenes extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, id) {
    if (event.isIntersecting) {
      this.props.trackSection(id);
    }
  }

  render() {
    return (
      <Fragment>
        <Observer onlyOnce onChange={event => this.handleChange(event, 'intro')}>
          <Intro />
        </Observer>
        <Observer onlyOnce onChange={event => this.handleChange(event, 'locatie')}>
          <Location />
        </Observer>
        {this.props.hasLocation && (
          <Fragment>
            <Observer onlyOnce onChange={event => this.handleChange(event, 'opkomst-zetels')}>
              <Seats />
            </Observer>
            <Observer onlyOnce onChange={event => this.handleChange(event, 'jouw-gemeente')}>
              <Result />
            </Observer>
            <Observer onlyOnce onChange={event => this.handleChange(event, 'footer')}>
              <Footer />
            </Observer>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default connect(state => ({ hasLocation: hasLocationSelector(state)}), { trackSection })(Scenes);



// WEBPACK FOOTER //
// ./src/scenes.js